import React from 'react';
import { relocationPages } from '../../data/relocation';
import SEO from '../../components/SEO';

const RelocationHealthcare = () => {
  const pageData = relocationPages.healthcare;

  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <SEO
        title="Healthcare in Mexico"
        description="Guide to healthcare in Mexico for expats. Public and private health insurance, top hospitals, and how to access quality medical care in Mexico City."
        path="/relocation/cdmx/healthcare"
      />
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F9F6EF] border-b border-[#F4ECD8]">
        <div className="container-wide mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
            </a>
            <nav className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm font-medium text-[#1A5C6E] hover:text-[#2CA8A0] transition">Home</a>
              <a href="/relocation/cdmx" className="text-sm font-medium text-[#0A1F2E]">Relocation</a>
              <a href="/contact" className="btn-primary text-xs px-6 py-3">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="section">
        <div className="container-wide mx-auto">
          <a href="/relocation/cdmx" className="inline-block text-sm font-medium text-[#5A6B73] mb-6 hover:text-[#2CA8A0] transition">
            ← Back to Relocation Hub
          </a>
          <p className="label mb-4">Relocation Hub</p>
          <h1 className="heading-xl mb-6">{pageData.title}</h1>
          <p className="body-lg max-w-3xl">{pageData.description}</p>
        </div>
      </section>

      {/* Healthcare Options */}
      <section className="section-sm bg-[#FFFFFF]">
        <div className="container-wide mx-auto">
          <h2 className="heading-lg mb-8 text-center">Healthcare Options</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {pageData.options.map((option, idx) => (
              <div key={idx} className="bg-[#FFFFFF] border border-[#E0D6B8] p-6">
                <h3 className="heading-sm mb-2">{option.name}</h3>
                <p className="body-md mb-4">{option.description}</p>
                
                {option.providers && (
                  <>
                    <h4 className="text-sm font-medium mb-2 text-[#0A1F2E]">Providers:</h4>
                    <p className="body-sm text-[#1A5C6E] mb-4">{option.providers.join(', ')}</p>
                  </>
                )}
                
                {option.notes && (
                  <p className="body-sm text-[#5A6B73] italic mb-4">{option.notes}</p>
                )}
                
                <p className="text-sm font-semibold text-[#2CA8A0]">{option.cost}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality */}
      <section className="section">
        <div className="container-narrow mx-auto">
          <h2 className="heading-lg mb-8 text-center">Healthcare Quality</h2>
          
          <div className="space-y-6">
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">World-Class Hospitals</h3>
              <p className="body-md">Mexico City has several internationally accredited hospitals including Hospital ABC, Médica Sur, and Hospital Ángeles. Many doctors trained in the US or Europe.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">English-Speaking Providers</h3>
              <p className="body-md">Most doctors in premium hospitals speak English. We can provide recommendations for English-speaking specialists across medical disciplines.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Dental & Vision</h3>
              <p className="body-md">High-quality dental and vision care at fraction of US prices. Many expats travel to Mexico specifically for dental work.</p>
            </div>
            <div>
              <h3 className="heading-sm mb-3">Pharmacies</h3>
              <p className="body-md">Farmacias del Ahorro and Farmacias Similares are ubiquitous. Many medications available without prescription. 24-hour pharmacies common.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-sm bg-[#FFFFFF] border-t border-[#F4ECD8]">
        <div className="container-narrow mx-auto text-center">
          <h2 className="heading-lg mb-4">Need Healthcare Guidance?</h2>
          <p className="body-md mb-8">
            Our relocation plans include healthcare recommendations and insurance partner introductions.
          </p>
          <a href="/relocation/blueprint" className="btn-primary">View Relocation Plans</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="section-sm border-t border-[#F4ECD8]">
        <div className="container-wide mx-auto text-center">
          <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
          <p className="body-sm">© {new Date().getFullYear()} Mundalo. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RelocationHealthcare;
